import { YearMonth } from '@square/dashboard-protos/models/squareup/common/time';
import assert from '@banking/ui/utils/assert';

/**
 * Converts an expiry date string in MMYY format to a YearMonth object
 * @param mmyy - The expiry date string in MMYY format (e.g., "1234" for December 2034)
 * @returns YearMonth object
 */
export function convertExpiryDateToYearMonth(mmyy) {
  assert(mmyy.length === 4 && !Number.isNaN(Number(mmyy)), 'mmyy must be a 4 digit number');
  const month = Number.parseInt(mmyy.slice(0, 2), 10);
  assert(month >= 1 && month <= 12, 'month of year must be between 1 and 12');
  const yearSuffix = mmyy.slice(2, 4);
  const year = Number.parseInt(`20${yearSuffix}`, 10);
  return YearMonth.create({
    monthOfYear: month,
    year
  });
}